<template>
  <a-form-item :label="label">
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-model:value="selected"
      :disabled="!portfolio"
      placeholder="Seleccionar base"
      class="form__select"
    >
      <a-select-option :key="defaultBehavior ? '' : 0"> Todas las bases </a-select-option>
      <a-select-option v-for="item in bases" :key="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
import { fetchAllBases } from "@/app/entities/services/requests/bases/fetchAllBases";

export default {
  props: {
    value: {
      required: true,
    },
    entity: {
      required: false,
    },
    portfolio: {
      required: false,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    defaultBehavior: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bases: [],
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
  watch: {
    portfolio(value) {
      this.selected = 0;
      this.fetchBases(value);
    },
  },
  created() {
    this.fetchBases();
  },
  methods: {
    async fetchBases() {
      const data = await fetchAllBases("", this.entity, this.portfolio, {}, "1");
      this.bases = data.results;
      this.$emit("finishLoading");
    },
  },
};
</script>

<style lang="sass" scoped>
.form__select
  width: 100%
  // width: 180px
</style>
